let language = {
    "dashboard:header:Title": "仪表板",
    "dashboard:part:Orders": "订单",
    "dashboard:CustomerOrders": "客户订单",
    "dashboard:CustomerOrderDetail": "订单详情",
    "dashboard:Combine": "拼单",
    "dashboard:PartnerOrders": "合作伙伴订单",
    "dashboard:SampleOrders": "样品订单",
    "dashboard:Returns": "退货",
    "dashboard:ReturnsDetail": "退货详情",
    
    "dashboard:part:Products": "产品",
    "dashboard:MyProducts": "我的产品",
    "dashboard:ProductsCatalog": "产品目录",

    "dashboard:ProductSticker": "产品贴纸",
    "dashboard:part:FileLibrary": "文件库",
    "dashboard:MySticker": "贴纸库",
    "dashboard:MyBackground": "背景库",
    "dashboard:MyForeground": "前景库",
    "dashboard:MyFileLibrary": "图库",
    
    "dashboard:MyStores": "我的商店",
    "dashboard:MyStoreEmailSetting": "发货邮件设置",
    
    "dashboard:part:MyStores": "我的商店",
    
    "dashboard:part:MyAccount": "我的账户",
    "dashboard:Payments": "支付",
    "dashboard:AddressBook": "地址簿",
    "dashboard:AddressBookDetail": "地址簿详情",
    "dashboard:Business": "商业信息",
    "dashboard:BillingMethods": "支付方式",
    "dashboard:BillingMethod": "新的支付方式",
    "dashboard:Taxes": "税费",
    "dashboard:MyAccount": "个人资料设置",
    "dashboard:CombineOrderSettings": "拼单设置",

    "route:homepage": "主页"
};

export { language }
